import { createSlice } from "@reduxjs/toolkit";
import { getAllPackages, getPackageServices } from "./thunk"; // Import the async thunks

const initialState = {
  Packages: [],
  PackageServices: [],

  loading: false,
  error: null,
};

const PackagesSlice = createSlice({
  name: "PackagesSlice",
  initialState,
  reducers: {
  
  },
  extraReducers: (builder) => {
    builder

      .addCase(getAllPackages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.Packages = action.payload
      })
      .addCase(getAllPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
      
    builder
      .addCase(getPackageServices.pending, (state) => {
        state.loading = true;
        state.PackageServices = [];
      })
      .addCase(getPackageServices.fulfilled, (state, action) => {
        state.loading = false;
        state.PackageServices = action.payload
      })
      .addCase(getPackageServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });




  },
  

});

export default PackagesSlice.reducer;
